
import { createContext } from 'react';

const CoreFormControllerContext = createContext(null);

export default CoreFormControllerContext;
